function drawImage(context, url, x, y, width, height) {
  return new Promise(resolve => {
    const image = new Image()
    image.onload = function() {
      context.drawImage(image, x, y, width, height)
      context.restore()
      resolve()
    }
    image.setAttribute('crossorigin', 'anonymous')
    image.src = url
  })
}
function circleImgOne(context, img, x, y, r, type) {
  context.save()
  const d = r * 2
  const cx = x + r
  const cy = y + r
  context.beginPath()
  context.arc(cx, cy, r, 0, 2 * Math.PI)
  if (type === 'headImg') {
    context.strokeStyle = '#FFFFFF' // 设置绘制圆形边框的颜色
    context.lineWidth = 15
    context.stroke() // 绘制出圆形，默认为黑色，可通过 ctx.strokeStyle = '#FFFFFF'， 设置想要的颜色
  }
  context.clip()
  context.closePath()
  return new Promise(resolve => {
    const image = new Image()
    image.onload = function() {
      context.drawImage(image, x + 1.5, y + 1, d - 2, d - 2)
      context.restore()
      resolve()
    }
    image.setAttribute('crossorigin', 'anonymous')
    image.src = img
  })
}

function creatCanvas(width, height) {
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  return canvas
}
function drawRoundRectPath(cxt, width, height, radius) {
  cxt.beginPath(0)
  // 从右下角顺时针绘制，弧度从0到1/2PI
  cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2)

  // 矩形下边线
  cxt.lineTo(radius, height)

  // 左下角圆弧，弧度从1/2PI到PI
  cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI)

  // 矩形左边线
  cxt.lineTo(0, radius)

  // 左上角圆弧，弧度从PI到3/2PI
  cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2)

  // 上边线
  cxt.lineTo(width - radius, 0)

  // 右上角圆弧
  cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2)

  // 右边线
  cxt.lineTo(width, height - radius)
  cxt.closePath()
}

function fillRoundRect(cxt, x, y, width, height, radius, /* optional */ fillColor) {
  // 圆的直径必然要小于矩形的宽高
  if (2 * radius > width || 2 * radius > height) {
    return false
  }
  console.log('开始画矩形')
  cxt.save()
  cxt.translate(x, y)
  // 绘制圆角矩形的各个边
  drawRoundRectPath(cxt, width, height, radius)
  cxt.fillStyle = fillColor || '#000' // 若是给定了值就用给定的值否则给予默认值
  cxt.shadowOffsetX = 0 // 阴影横向位移
  cxt.shadowOffsetY = 0 // 阴影纵向位移
  cxt.shadowColor = 'rgba(182, 182, 182, 0.35)' // 阴影颜色
  cxt.shadowBlur = 16 // 阴影模糊范围
  cxt.fill()
  cxt.restore()
}
export async function drawPoster({ posterBg, code, userName, headImg, type }) {
  // const scaleBy = window.devicePixelRatio || 1
  const scaleBy = 1
  const canvas = creatCanvas(750 * scaleBy, 1200 * scaleBy)
  const context = canvas.getContext('2d')
  // 绘制底图
  await drawImage(context, posterBg, 0, 0, 750 * scaleBy, 1200 * scaleBy)
  if (type === 0) {
    fillRoundRect(context, 85, 790, 284, 58, 29, '#ffffff')
    // 用户姓名
    context.font = 34 * scaleBy + 'px "PingFangSC-Semibold"'
    context.fillStyle = '#666666'
    context.textBaseline = 'middle'
    context.textAlign = 'left'
    context.fillText(userName, 153 * scaleBy, 822 * scaleBy)
    // 绘制头像
    await circleImgOne(context, headImg, 54 * scaleBy, 776 * scaleBy, 44 * scaleBy, 'headImg')
  }
  // 绘制二维码
  await circleImgOne(context, code, 549 * scaleBy, 997 * scaleBy, 67 * scaleBy)
  // context.restore()
  return canvas.toDataURL('image/png')
}

export function formatDate(dateStr, separator) {
  if (!separator) {
    separator = '-'
  }
  const dateArr = dateStr.split(separator)
  let month
  if (dateArr[1].indexOf('0') === 0) {
    month = parseInt(dateArr[1].substring(1))
  } else {
    month = parseInt(dateArr[1])
  }
  const day = parseInt(dateArr[2])
  return `${month}.${day}`
}
